export default __webpack_public_path__ + "static/media/cover-auth-notal.3deb14af.png";